import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { handleReauthenticate } from "./SignIn";
import {
    RECAPTCH_CONTAINER_ID,
    RECAPTCHA_REAUTH_CONTAINER_SUFFIX,
} from "../../config/index";

export default function ReAuthDialog({
    open,
    setOpen,
    handler,
    dialogSuffix = "",
    isLoading = false,
}) {
    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitAndClose = async (event) => {
        await handleReauthenticate(
            event,
            RECAPTCHA_REAUTH_CONTAINER_SUFFIX + dialogSuffix
        );
        await handler();
        setOpen(false);
    };
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                sx={{ zIndex: isLoading ? -1 : 1300 }}
            >
                <DialogTitle>Verify</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To proceed with the selected action, please enter your
                        credentials here.
                    </DialogContentText>
                    <Box
                        component="form"
                        onSubmit={handleSubmitAndClose}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button type="submit">Verify</Button>
                        </DialogActions>
                        <div
                            id={
                                RECAPTCH_CONTAINER_ID +
                                RECAPTCHA_REAUTH_CONTAINER_SUFFIX +
                                dialogSuffix
                            }
                        ></div>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
}
